import { defineStore } from 'pinia';
import { i18n } from '../i18n.js';
import { ref } from 'vue';

const TranslatedMessages = {
  'Failed to fetch': i18n.global.t('common.toast.failedToFetch'),
};

// to be honest other apps could use some pinia too
export const useToastStore = defineStore('ToastStore', () => {

  const toasts = ref([]);

  const showToast = (message, options = {}) => {
    const translatedMessage = message in TranslatedMessages ? TranslatedMessages[message] : message;
    const rand = Math.random().toFixed(48).split('.')[1];
    const toast = {
      message: translatedMessage,
      id: rand,
      duration: 4000,
      color: 'warning',
      ...options,
    };

    toasts.value.push(toast);

    if (toast.duration !== 0 && toast.color !== 'error') {
      setTimeout(() => {
        toasts.value = toasts.value.filter((t) => t.id !== toast.id);
      }, toast.duration);
    }
  };

  const removeToast = (toast) => {
    toasts.value = toasts.value.filter((t) => t.id !== toast.id);
  };

  const showError = (message, options = {}) => {
    showToast(
      message,
      {
        color: 'error',
        ...options,
      },
    );
  };

  const showSuccess = (message, options = {}) => {
    showToast(
      message,
      {
        color: 'success',
        ...options,
      },
    );
  };

  const showWarning = (message, options = {}) => {
    showToast(
      message,
      {
        color: 'warning',
        ...options,
      },
    );
  };

  const showCommonUpdateErrors = (typename, catchUnknown = true) => {
    if (typename === 'UnitNotFoundError') {
      showError(i18n.t('unit.unitNotFound'));
      return;
    }

    if (typename === 'UnitNotPairedError') {
      showError(i18n.t('unit.unitNotPaired'));
      return;
    }

    if (typename === 'UnitAccessDeniedError') {
      showError(i18n.t('unit.unitAccessDenied'));
      return;
    }

    // if catchUnknown === false only above types will be caught,
    // this function then can be used outside any other conditional
    if (catchUnknown) {
      showError(i18n.t('common.error.unknownResponseType', { typename: typename }));
    }
  };

  return {
    toasts,
    showToast,
    removeToast,
    showError,
    showSuccess,
    showWarning,
    showCommonUpdateErrors,
  };

});
